import { PositionInTheCompanyChoice } from "@dune/types";
import {
	Card,
	ControlledDropdown,
	ControlledInput,
	ControlledPhoneInput,
	ControlledRadioGroup,
	cn,
} from "@dune/ui";
import { Control, FieldErrors } from "react-hook-form";
import { PartnershipRequestAnalysisFormData } from "../usePartnershipRequestAnalysis";

interface UserSectionProps {
	control: Control<PartnershipRequestAnalysisFormData>;
	errors: FieldErrors<PartnershipRequestAnalysisFormData>;
	isPanelOpen: boolean;
}

export const UserSection = ({
	control,
	errors,
	isPanelOpen,
}: UserSectionProps) => {
	return (
		<div className={!isPanelOpen ? "xl:w-2/3" : ""}>
			<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
				<div
					className={cn("flex flex-col gap-4", !isPanelOpen && "md:flex-row")}
				>
					<div className="flex flex-col items-start gap-3 w-full">
						<ControlledInput
							label="Nom"
							control={control}
							name="lastname"
							error={errors.lastname?.message?.toString()}
						/>
					</div>
					<div className="flex flex-col items-start gap-3 w-full">
						<ControlledInput
							label="Prénom"
							control={control}
							name="firstname"
							error={errors.firstname?.message?.toString()}
						/>
					</div>
				</div>

				<div
					className={cn("flex flex-col gap-4", !isPanelOpen && "md:flex-row")}
				>
					<ControlledInput
						label="Email"
						control={control}
						name="email"
						error={errors.email?.message?.toString()}
					/>
					<ControlledDropdown
						name="position"
						control={control}
						options={PositionInTheCompanyChoice}
						label="Fonction dans l'entreprise"
						error={errors.position?.message?.toString()}
					/>
				</div>
				<div
					className={cn("flex flex-col gap-4", !isPanelOpen && "md:flex-row")}
				>
					<ControlledPhoneInput
						control={control}
						name="landlinePhone"
						placeholder="Ex : +33 1 23 45 67 89"
						defaultCountry="FR"
						label="Téléphone fixe"
					/>
					<ControlledPhoneInput
						control={control}
						name="phone"
						placeholder="Ex : +33 1 23 45 67 89"
						defaultCountry="FR"
						label="Mobile"
					/>
				</div>
				<div className="flex flex-col gap-2">
					<ControlledRadioGroup
						control={control}
						name="isSignatory"
						label="Le prospect est habilité à signer la convention de partenariat ?"
						items={[
							{
								id: "isSignatory-true",
								value: "true",
								label: "Oui",
							},
							{
								id: "isSignatory-false",
								value: "false",
								label: "Non",
							},
						]}
					/>
				</div>
			</Card>
		</div>
	);
};
